// src/components/StallAuth.js
import React, { useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import './StallAuth.css';

const url = process.env.REACT_APP_SERVER_URL || "https://food.stall-centralsoft.com/api";

export default function StallAuth() {
  const [stallID, setStallID] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [showRegister, setShowRegister] = useState(false);
  const [registerData, setRegisterData] = useState({
    stallID: "",
    username: "",
    password: "",
    confirmPassword: ""
  });

  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();
    if (!stallID || !password) {
      setError("Please fill in all fields");
      return;
    }

    setLoading(true);
    setError("");

    try {
      const response = await axios.post(`${url}/api/admin/login`, {
        stallID,
        password
      });

      if (response.data.success) {
        localStorage.setItem("stallID", stallID);
        localStorage.setItem("username", response.data.username);
        // Redirect to MobileOrderPage after successful login
        navigate("/MobileOrderPage");
      } else {
        setError(response.data.message || "Login failed");
      }
    } catch (error) {
      setError(error.response?.data?.error || "Login failed. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  const handleRegister = async (e) => {
    e.preventDefault();
    const { stallID, username, password, confirmPassword } = registerData;

    if (!stallID || !username || !password || !confirmPassword) {
      setError("Please fill in all fields");
      return;
    }

    if (password !== confirmPassword) {
      setError("Passwords do not match");
      return;
    }

    setLoading(true);
    setError("");

    try {
      const response = await axios.post(`${url}/api/admin/register`, {
        stallID,
        username,
        password
      });

      if (response.data.success) {
        // Auto login after successful registration
        localStorage.setItem("stallID", stallID);
        localStorage.setItem("username", username);
        navigate("/MobileOrderPage");
      } else {
        setError(response.data.message || "Registration failed");
      }
    } catch (error) {
      setError(error.response?.data?.error || "Registration failed. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  if (showRegister) {
    return (
      <div className="stall-auth-container">
        <div className="stall-auth-card">
          <h2>Register Stall</h2>

          {error && <div className="error-message">{error}</div>}

          <form onSubmit={handleRegister}>
            <input
              type="text"
              placeholder="Stall ID"
              value={registerData.stallID}
              onChange={(e) => setRegisterData({...registerData, stallID: e.target.value})}
              required
            />
            <input
              type="text"
              placeholder="Stall Name"
              value={registerData.username}
              onChange={(e) => setRegisterData({...registerData, username: e.target.value})}
              required
            />
            <input
              type="password"
              placeholder="Password"
              value={registerData.password}
              onChange={(e) => setRegisterData({...registerData, password: e.target.value})}
              required
            />
            <input
              type="password"
              placeholder="Confirm Password"
              value={registerData.confirmPassword}
              onChange={(e) => setRegisterData({...registerData, confirmPassword: e.target.value})}
              required
            />

            <button type="submit" disabled={loading}>
              {loading ? "Registering..." : "Register"}
            </button>
          </form>

          <p>
            Already have an account?{" "}
            <span className="link" onClick={() => setShowRegister(false)}>
              Login here
            </span>
          </p>
        </div>
      </div>
    );
  }

  return (
    <div className="stall-auth-container">
      <div className="stall-auth-card">
        <h2>Stall Login</h2>

        {error && <div className="error-message">{error}</div>}

        <form onSubmit={handleLogin}>
          <input
            type="text"
            placeholder="Stall ID"
            value={stallID}
            onChange={(e) => setStallID(e.target.value)}
            required
          />
          <input
            type="password"
            placeholder="Password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
          />

          <button type="submit" disabled={loading}>
            {loading ? "Logging in..." : "Login"}
          </button>
        </form>

        <p>
          Don't have an account?{" "}
          <span className="link" onClick={() => setShowRegister(true)}>
            Register here
          </span>
        </p>
      </div>
    </div>
  );
}
